import React from 'react'
import SectionFour from '../Landing/SectionFour'

const AllServices = () => {
    return (
        <div>
            <SectionFour />
        </div>
    )
}

export default AllServices